export default "__VITE_ASSET__yLbzgiBL__"